import { render, staticRenderFns } from "./HomeWidgets.vue?vue&type=template&id=5406b721&scoped=true&"
import script from "./HomeWidgets.vue?vue&type=script&lang=ts&"
export * from "./HomeWidgets.vue?vue&type=script&lang=ts&"
import style0 from "./HomeWidgets.vue?vue&type=style&index=0&id=5406b721&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5406b721",
  null
  
)

export default component.exports